import { Module } from "wrapper6";
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css'

const $ = jQuery

export default class ImageSlider extends Module {

  ready(app) {

    this.CONTAINERS = document.querySelectorAll('.mtt-image-slider .swiper-container')
    if (this.CONTAINERS.length) {
      for (let i = 0; i < this.CONTAINERS.length; i++) {
        const CONTAINER = this.CONTAINERS[i];
        const COUNTER = CONTAINER.querySelectorAll('.swiper-slide').length;

        this.SWIPER = new Swiper(CONTAINER, {
          slidesPerView: 1.05,
          spaceBetween: 20,
          lazy: true,
          grabCursor: true,
          watchOverflow: true,
          freeMode: false,
          breakpoints: {
            451: { slidesPerView: 1.25 },
            581: { slidesPerView: 2 },
            961: { slidesPerView: 3 },
          },
          navigation: {
            nextEl: '.mtt-swiper-button-next',
            prevEl: '.mtt-swiper-button-prev',
          },
        });
      }
    }
  }
}